import { ɵgetAllInstancesOf, ɵgetDefaultInstanceOf, VERSION, ɵAngularFireSchedulers, ɵAppCheckInstances, ɵzoneWrap } from '@angular/fire';
import { from, timer } from 'rxjs';
import { concatMap, distinct } from 'rxjs/operators';
import * as i0 from '@angular/core';
import { InjectionToken, Optional, NgModule, NgZone, Injector, makeEnvironmentProviders } from '@angular/core';
import { FirebaseApp, FirebaseApps } from '@angular/fire/app';
import { AuthInstances } from '@angular/fire/auth';
import { registerVersion } from 'firebase/app';
import { fromTask as fromTask$1, percentage as percentage$1 } from 'rxfire/storage';
import { connectStorageEmulator as connectStorageEmulator$1, deleteObject as deleteObject$1, getBlob as getBlob$1, getBytes as getBytes$1, getDownloadURL as getDownloadURL$1, getMetadata as getMetadata$1, getStorage as getStorage$1, getStream as getStream$1, list as list$1, listAll as listAll$1, ref as ref$1, updateMetadata as updateMetadata$1, uploadBytes as uploadBytes$1, uploadBytesResumable as uploadBytesResumable$1, uploadString as uploadString$1 } from 'firebase/storage';
export * from 'firebase/storage';
class Storage {
  constructor(auth) {
    return auth;
  }
}
const STORAGE_PROVIDER_NAME = 'storage';
class StorageInstances {
  constructor() {
    return ɵgetAllInstancesOf(STORAGE_PROVIDER_NAME);
  }
}
const storageInstance$ = /*#__PURE__*/ /*#__PURE__*/timer(0, 300).pipe( /*#__PURE__*/concatMap(() => from(ɵgetAllInstancesOf(STORAGE_PROVIDER_NAME))), /*#__PURE__*/distinct());
const PROVIDED_STORAGE_INSTANCES = /*#__PURE__*/new InjectionToken('angularfire2.storage-instances');
function defaultStorageInstanceFactory(provided, defaultApp) {
  const defaultStorage = ɵgetDefaultInstanceOf(STORAGE_PROVIDER_NAME, provided, defaultApp);
  return defaultStorage && new Storage(defaultStorage);
}
function storageInstanceFactory(fn) {
  return (zone, injector) => {
    const storage = zone.runOutsideAngular(() => fn(injector));
    return new Storage(storage);
  };
}
const STORAGE_INSTANCES_PROVIDER = {
  provide: StorageInstances,
  deps: [[/*#__PURE__*/new Optional(), PROVIDED_STORAGE_INSTANCES]]
};
const DEFAULT_STORAGE_INSTANCE_PROVIDER = {
  provide: Storage,
  useFactory: defaultStorageInstanceFactory,
  deps: [[/*#__PURE__*/new Optional(), PROVIDED_STORAGE_INSTANCES], FirebaseApp]
};
let StorageModule = /*#__PURE__*/(() => {
  class StorageModule {
    constructor() {
      registerVersion('angularfire', VERSION.full, 'gcs');
    }
    static ɵfac = function StorageModule_Factory(t) {
      return new (t || StorageModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: StorageModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [DEFAULT_STORAGE_INSTANCE_PROVIDER, STORAGE_INSTANCES_PROVIDER]
    });
  }
  return StorageModule;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function provideStorage(fn, ...deps) {
  registerVersion('angularfire', VERSION.full, 'gcs');
  return makeEnvironmentProviders([DEFAULT_STORAGE_INSTANCE_PROVIDER, STORAGE_INSTANCES_PROVIDER, {
    provide: PROVIDED_STORAGE_INSTANCES,
    useFactory: storageInstanceFactory(fn),
    multi: true,
    deps: [NgZone, Injector, ɵAngularFireSchedulers, FirebaseApps,
    // Defensively load Auth first, if provided
    [new Optional(), AuthInstances], [new Optional(), ɵAppCheckInstances], ...deps]
  }]);
}

// DO NOT MODIFY, this file is autogenerated by tools/build.ts
const fromTask = /*#__PURE__*/ɵzoneWrap(fromTask$1, true);
const percentage = /*#__PURE__*/ɵzoneWrap(percentage$1, true);

// DO NOT MODIFY, this file is autogenerated by tools/build.ts
const connectStorageEmulator = /*#__PURE__*/ɵzoneWrap(connectStorageEmulator$1, true);
const deleteObject = /*#__PURE__*/ɵzoneWrap(deleteObject$1, true);
const getBlob = /*#__PURE__*/ɵzoneWrap(getBlob$1, true);
const getBytes = /*#__PURE__*/ɵzoneWrap(getBytes$1, true);
const getDownloadURL = /*#__PURE__*/ɵzoneWrap(getDownloadURL$1, true);
const getMetadata = /*#__PURE__*/ɵzoneWrap(getMetadata$1, true);
const getStorage = /*#__PURE__*/ɵzoneWrap(getStorage$1, true);
const getStream = /*#__PURE__*/ɵzoneWrap(getStream$1, true);
const list = /*#__PURE__*/ɵzoneWrap(list$1, true);
const listAll = /*#__PURE__*/ɵzoneWrap(listAll$1, true);
const ref = /*#__PURE__*/ɵzoneWrap(ref$1, true);
const updateMetadata = /*#__PURE__*/ɵzoneWrap(updateMetadata$1, true);
const uploadBytes = /*#__PURE__*/ɵzoneWrap(uploadBytes$1, true);
const uploadBytesResumable = /*#__PURE__*/ɵzoneWrap(uploadBytesResumable$1, true);
const uploadString = /*#__PURE__*/ɵzoneWrap(uploadString$1, true);

/**
 * Generated bundle index. Do not edit.
 */

export { Storage, StorageInstances, StorageModule, connectStorageEmulator, deleteObject, fromTask, getBlob, getBytes, getDownloadURL, getMetadata, getStorage, getStream, list, listAll, percentage, provideStorage, ref, storageInstance$, updateMetadata, uploadBytes, uploadBytesResumable, uploadString };
